module.exports = __webpack_public_path__ + "static/img/pwr_PL_white.8a229e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pwr_PL_white.png
// module id = cJqL
// module chunks = 0